<template>
    <section class="" :style="{ backgroundColor: backgroundColor }">
        <div class="grid grid-cols-12">
            <div class="col-span-12 lg:col-span-6 xl:pr-32">
                <nuxt-img :src="imageSrc" :alt="imageAlt" :width="width" :height="height"
                    sizes="xs:330px sm:440px md:760px lg:1023px xl:493px 2xl:989px" loading="lazy" format="webp"
                    class="w-full mx-auto" />
            </div>

            <div
                class="lg:col-span-6 col-span-12 2xl:mr-[calc((100vw_-_1280px)_/_2)] xl:pr-12 xl:pl-0 px-6 md:px-8 lg:py-0 py-8">
                <div class="flex flex-col justify-center h-full">
                    <h2 class="text-2xl text-center xl:text-4xl md:text-3xl font-ww-medium md:text-left">
                        {{ heading }}
                    </h2>
                    <div class="lg:mt-4 mt-2 text-base xl:text-lg font-ww-regular !leading-6 xl:pr-16 text-left lg:max-w-lg" v-html="description"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    heading: {
        type: String,
        default: "One Pure Ingredient"
    },
    description: {
        type: String,
        default: `
        This Valentine's Day, fill your mug with our indulgent chocolate covered strawberry coffee and savor the taste and fragrance of heaven. <br><br>
  
        All natural extracts of sweet, sun-ripened, juicy strawberries come alive beneath a blanket of silky, smooth, creamy milk chocolate as this confectionery favorite perfectly pairs with our single origin, low acid, medium roast specialty beans.<br><br>
  
        Breathing in the pleasantly sweet aroma as you brew will have you anxiously awaiting your first sip, and once you indulge, this classic, yet incredible, flavor combination will keep you coming back for more. 
      `
    },
    imageSrc: {
        type: String,
        default: "/assets/images/chocolate-covered.png"
    },
    imageAlt: {
        type: String,
        default: "Chocolate Covered Strawberry"
    },
    backgroundColor: {
        type: String,
        default: "white"
    },
    width: {
        type: [Number, String],
        default: 1211
    },
    height: {
        type: [Number, String],
        default: 1305
    }
});

defineBuilderComponent({
    friendlyName: "InfoWithFullLeftImageStyleTwo",
    inputs: [
        {
            name: "heading",
            type: "string",
            friendlyName: "Heading",
            defaultValue: "One Pure Ingredient"
        },
        {
            name: "description",
            type: "richText",
            friendlyName: "Description",
            defaultValue: `
          This Valentine's Day, fill your mug with our indulgent chocolate covered strawberry coffee and savor the taste and fragrance of heaven. <br><br>
  
          All natural extracts of sweet, sun-ripened, juicy strawberries come alive beneath a blanket of silky, smooth, creamy milk chocolate as this confectionery favorite perfectly pairs with our single origin, low acid, medium roast specialty beans.<br><br>
  
          Breathing in the pleasantly sweet aroma as you brew will have you anxiously awaiting your first sip, and once you indulge, this classic, yet incredible, flavor combination will keep you coming back for more. 
        `
        },
        {
            name: "imageSrc",
            type: "file",
            friendlyName: "Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/chocolate-covered.png"
        },
        {
            name: "imageAlt",
            type: "string",
            friendlyName: "Image Alt Text",
            defaultValue: "Chocolate Covered Strawberry"
        },
        {
            name: "backgroundColor",
            type: "color",
            friendlyName: "Background Color",
            defaultValue: "white"
        },
        {
            name: "width",
            type: "number",
            friendlyName: "Image Width",
            defaultValue: 1211
        },
        {
            name: "height",
            type: "number",
            friendlyName: "Image Height",
            defaultValue: 1305
        }
    ]
});
</script>